export const form = () => ({
    padding: '3rem 2rem 5rem',
    maxWidth: '796px',
});
